import React, { useRef } from 'react';
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import HomeIcon from '@material-ui/icons/Home'
import {  Hidden } from '@material-ui/core';
import { Link } from 'react-router-dom';
import useLanguage from '../hooks/UseLanguage';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerContainer: {
        overflow: 'auto',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

const AppDrawer = (props) => {
    const classes = useStyles();

    const t = useLanguage()

    const drawer = (
        <div className={classes.drawerContainer}>
            <List>
                <Link to="/" color="inherit" >
                    <ListItem button on key="home" >
                        <ListItemIcon> <HomeIcon /></ListItemIcon>
                        <ListItemText primary={t('routes.drawer.home')} />
                    </ListItem>
                </Link>
                <Link to="/products">
                    <ListItem button on key="products" >
                        <ListItemIcon> <InboxIcon /></ListItemIcon>
                        <ListItemText primary={t('routes.drawer.products')} />
                    </ListItem>
                </Link>
            </List>
            <Divider />
        </div>
    )

    return (
        <div className={classes.root}>
                <Hidden mdUp implementation="css">
                    <Drawer

                        {...props}

                        variant="temporary"
                        classes={{
                            paper: classes.drawerPaper,
                        }}

                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden smDown implementation="css">
                    <Drawer
                        className={classes.drawer}
                        variant="permanent"
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <Toolbar />
                        {drawer}
                    </Drawer>
                </Hidden>
                <main className={classes.content}   >
                    <Toolbar />
                    {props.children}
                </main>
            </div>
    );
}

AppDrawer.propTypes = {
    open: PropTypes.bool.isRequired
};

export default AppDrawer